import {Icon24QuestionOutline} from "@vkontakte/icons";
import {Button, Div} from "@vkontakte/vkui";
import React from "react";
import {getGUID} from "./constants";


class HelpButton extends React.Component {
    state = {
        showPopup: false
    }

    render() {
        return <div key={getGUID()}>
            <Button style={{minWidth: "41px", ...this.props.style}}
                    before={this.props.icon ?? <Icon24QuestionOutline width={this.props.size ?? 32}/>}
                    stretched={this.props.strethed}
                    onClick={() => this.props.showPopup ? this.setState({showPopup: !this.state.showPopup}) : window.postMessage({
                        type: "helpMessage",
                        text: this.props.text
                    })}
                    mode={this.props.mode ?? "tertiary"}>
                {this.props.title ?? ''}
            </Button>
            {this.props.showPopup && this.state.showPopup && <Div>{this.props.text}</Div>}
        </div>

    }
}

export default HelpButton